import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { Cart } from 'types/cartServiceV2';
import { InputFilter } from 'types/domainServiceV2';
import { RFQChecklist } from 'types/enrollmentService';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { getCart } from 'api/operations/cartServiceV2';
import { getDomainProductLine } from 'api/operations/domainServiceV2';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';

export default class RFQProposalChecklistStore {
  rootStore: RootStore;
  loading = false;
  checklist: RFQChecklist | null = null;
  productLineIds: ProductLineId[] = [];
  groupId: string | null = null;
  private _enrollmentPeriodModule = new EnrollmentPeriodModule();

  private setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public async getProposalChecklist(cartId: string, periodId: string): Promise<void> {
    // If period id exists initiate rfq was submitted
    if (periodId) {
      this.setLoading(true);
      const results = await Promise.all([
        getCart(cartId),
        this._enrollmentPeriodModule.uploadEnrollmentPeriod(periodId),
      ]);

      await runInAction(async () => {
        const cartData = results[0];
        if (!cartData) throw new Error(`The cart with such id doesn't exist: ${cartId}`);

        this.groupId = cartData.groupId;
        this.checklist = this._enrollmentPeriodModule.rfqProposalChecklistData(cartId).checklist || null;
        await this.getProductLines(cartData, cartData.rateSegment);
        this.setLoading(false);
      });
    }
  }

  private async getProductLines(cart: Cart, rateSegment: RateSegment): Promise<void> {
    const inputFilter: InputFilter = {
      effectiveDate: cart.lastUpdateBrowsingCriteria.effectiveDate,
      zipCode: cart.lastUpdateBrowsingCriteria.zipCode,
      state: cart.lastUpdateBrowsingCriteria.state,
      county: cart.lastUpdateBrowsingCriteria.county,
      agencyId: this.rootStore.userStore.imAgencyId,
      sponsorId: this.rootStore.userStore.sponsorId,
    };

    const res = await getDomainProductLine(inputFilter);

    runInAction(() => {
      this.productLineIds = res.filter((line) => line.rateSegment === rateSegment).map((pLine) => pLine.productLineId); // filter out product lines that have different rate segment
    });
  }

  public getGroupIdToRedirect(cartId: string): string {
    const data = this._enrollmentPeriodModule.rfqProposalChecklistData(cartId);
    return (this.rootStore.userStore.sponsorId !== data.sponsorId && data.parentGroupId) || data.groupId;
  }

  public resetProposalInfo(): void {
    this.checklist = null;
    this.productLineIds = [];
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
